import { createRoutine } from 'redux-saga-routines';

export const addDepToPeriodRoutine = createRoutine('TIMELINE/ADD_DEP_TO_PERIOD');
export const removeDepFromPeriodRoutine = createRoutine('TIMELINE/REMOVE_DEP_FROM_PERIOD');